import type { Voter } from '../../common/types';
import type { StoreApi, LoggedInUserAction } from './types';

export const setVoters =
	(voters: Voter[]) =>
	({ setState }: StoreApi) => {
		setState({
			voters,
		});
	};

export const setLoggedInUserAction =
	(loggedInUserAction: LoggedInUserAction) =>
	({ setState }: StoreApi) => {
		setState({
			loggedInUserAction,
		});
	};
